<script setup lang="ts">
import { GpAvatar } from '@gportal/uikit';
import { useAvatarStore } from 'gpcore-apikit/store/pinia/avatar';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import { computed } from 'vue';

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const avatarStore = useAvatarStore();
const avatarKey = computed(() => {
  if (session.value != null) {
    console.log(avatarStore.avatars);
    const avatarId = Object.keys(avatarStore.avatars).find((key) => key === session.value.user.id);

    if (avatarId == null) {
      return null;
    }

    return avatarStore.avatars[avatarId];
  }

  return 'default';
});
</script>

<template>
  <GpAvatar
    :src="session.user.avatarUrl"
    :alt="session.user.username"
    rounded
    custom-size
    :key="avatarKey"
  />
</template>

<style scoped></style>
